export const shCurrencyPipe = (amount) => {
    // exclude case if amount is exactly 0
    if (!amount && amount !== 0) {
        return amount;
    }

    let decimalCount = 2;
    let decimal = ",";
    let thousands = ".";

    try {
        decimalCount = Math.abs(decimalCount);
        decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

        // there should be a negative sign
        const negativeSign = "";

        let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
        let j = (i.length > 3) ? i.length % 3 : 0;

        return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "") + ("\xA0€");
    } catch (e) {
        console.error('*** shCurrencyPipe', e);
        return amount;
    }
}
